<ng-content
  select="icon:not([iconPositionEnd]), sb-icon:not([iconPositionEnd]),sb-spinner:not([iconPositionEnd])"
></ng-content>
<span class="truncate"><ng-content></ng-content></span>
<ng-content select="icon[iconPositionEnd], sb-icon[iconPositionEnd], sb-spinner[iconPositionEnd]"></ng-content>
